import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=594f5642&scoped=true&"
import script from "./divider.js?vue&type=script&lang=js&"
export * from "./divider.js?vue&type=script&lang=js&"
import style0 from "./divider.scss?vue&type=style&index=0&id=594f5642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f5642",
  null
  
)

export default component.exports